export const commonFonts = {
  display: "'Insanibc', sans-serif",
  body: "'Quicksand', sans-serif",
  minimal: "'LTRemark', sans-serif",
}